var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomToComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 96 960 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 727V160q0-27.625 18.688-46.312Q44.374 95 72 95h561.013q28.312 0 47.149 18.688Q699 132.375 699 160v399q0 27.625-18.975 46.312Q661.05 624 633 624H193L66.267 750.733Q49 768 28 759q-21-9-21-32Zm274 152q-28.85 0-46.925-18.975Q216 841.05 216 813V704h563V306h108.773q28.002 0 46.615 18.688Q953 343.375 953 371v603q0 23-21 32.5t-38-6.5L774 879H281Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomToComment);
export default __webpack_public_path__ + "static/media/custom-to-comment.5004249649ab5caf69b97499766c86d6.svg";
export { ForwardRef as ReactComponent };